"use client";

import React from "react";
import { useTranslation } from "react-i18next";

const TermsOfUsePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-8 font-sans leading-relaxed max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8">
        {t("terms_of_use_page.title")}
      </h1>
      <p>
        <strong className="font-semibold">
          {t("terms_of_use_page.effective_date")}:
        </strong>{" "}
        {t("terms_of_use_page.date_placeholder")}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.agreement_title")}
      </h2>
      <p className="mb-4">{t("terms_of_use_page.agreement_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.use_license_title")}
      </h2>
      <p className="mb-4">{t("terms_of_use_page.use_license_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.intellectual_property_title")}
      </h2>
      <p className="mb-4">
        {t("terms_of_use_page.intellectual_property_content")}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.disclaimer_title")}
      </h2>
      <p className="mb-4">{t("terms_of_use_page.disclaimer_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.liability_limitation_title")}
      </h2>
      <p className="mb-4">
        {t("terms_of_use_page.liability_limitation_content")}
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.governing_law_title")}
      </h2>
      <p className="mb-4">{t("terms_of_use_page.governing_law_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.changes_title")}
      </h2>
      <p className="mb-4">{t("terms_of_use_page.changes_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("terms_of_use_page.contact_title")}
      </h2>
      <p className="mb-2">{t("terms_of_use_page.contact_content")}</p>
      <p className="mb-2">
        {t("terms_of_use_page.contact_email_label")}{" "}
        <a
          href={`mailto:${t("terms_of_use_page.contact_email")}`}
          className="text-blue-600 hover:underline"
        >
          {t("terms_of_use_page.contact_email")}
        </a>
      </p>
      <p className="mb-4">
        {t("terms_of_use_page.contact_phone_label")}{" "}
        <a
          href={`tel:${t("terms_of_use_page.contact_phone")}`}
          className="text-blue-600 hover:underline"
        >
          {t("terms_of_use_page.contact_phone")}
        </a>
      </p>
    </div>
  );
};

export default TermsOfUsePage;
